import { Icon } from '@iconify/react';
import { useState } from 'react';
import { capitalCase } from 'change-case';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import roundAccountBox from '@iconify/icons-ic/round-account-box';
import roundPowerSettingsNew from '@iconify/icons-ic/round-power-settings-new';

// material
import {
  Box,
  List,
  Select,
  Divider,
  Popover,
  Tooltip,
  ListItem,
  Typography,
  IconButton,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Grid,
  Paper
} from '@material-ui/core';
import Search from './searchContact/Search';
import AnalyticsWeeklySales from '../../../general-analytics/AnalyticsWeeklySales';
import AnalyticsNewUsers from '../../../general-analytics/AnalyticsNewUsers';
import AnalyticsItemOrders from '../../../general-analytics/AnalyticsItemOrders';
import AnalytysStatistical from '../../../general-analytics/AnalytysStatistical';
import AnalytysStatisticalContactSystem from '../../../general-analytics/AnalytysStatisticalContactSystem';


// ----------------------------------------------------------------------

const STATUS = ['online', 'invisible', 'away'];

export default function ReportListContact({ handleParamSearchBox, records }) {
  const [channelSelected, setChannelSelected] = useState();
  // const total_contact_all = records.total_contact_all['total_contact_all'].length > 0 ? records.total_contact_all['total_contact_all'][0]['total_contact_all'] : 0;
  // const total_contact_facebook = records.total_contact_facebook['total_contact_facebook'].length > 0 ? records.total_contact_facebook['total_contact_facebook'][0]['total_contact_facebook'] : 0;
  // const total_contact_zalo = records.total_contact_zalo['total_contact_zalo'].length > 0 ? records.total_contact_zalo['total_contact_zalo'][0]['total_contact_zalo'] : 0;
  // const total_contact_system = records.total_contact_system['total_contact_system'].length > 0 ? records.total_contact_system['total_contact_system'][0]['total_contact_system'] : 0;
  const onChangeChannel = (item) => {
    setChannelSelected(item.channel);
    handleParamSearchBox(item);

  }
  const total_contact_all = records?.total_contact_all && records?.total_contact_all.length > 0 && records?.total_contact_all[0]['total_contact_all'] ? records?.total_contact_all[0]['total_contact_all'] : 0;
  const total_contact_facebook = records?.total_contact_facebook && records?.total_contact_facebook.length > 0 && records?.total_contact_facebook[0]['total_contact_facebook'] ? records?.total_contact_facebook[0]['total_contact_facebook'] : 0;
  const total_contact_zalo = records?.total_contact_zalo && records?.total_contact_zalo.length > 0 && records?.total_contact_zalo[0]['total_contact_zalo'] ? records?.total_contact_zalo[0]['total_contact_zalo'] : 0;
  const total_contact_system = records?.total_contact_system && records?.total_contact_system.length > 0 && records?.total_contact_system[0]['total_contact_system'] ? records?.total_contact_system[0]['total_contact_system'] : 0;
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper onClick={() => onChangeChannel({ channel: "all" })} sx={{ cursor: 'pointer', '&:hover': { opacity: 0.72 } }}>
            <AnalytysStatistical channelSelected={channelSelected} value={total_contact_all} title="Tổng danh bạ" />
          </Paper>

        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper onClick={() => onChangeChannel({ channel: "facebook" })} sx={{ cursor: 'pointer', '&:hover': { opacity: 0.72 } }}>
            <AnalyticsNewUsers channelSelected={channelSelected} value={total_contact_facebook} title="Tổng danh bạ từ facebook" />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper onClick={() => onChangeChannel({ channel: "zalo" })} sx={{ cursor: 'pointer', '&:hover': { opacity: 0.72 } }}>
            <AnalyticsItemOrders channelSelected={channelSelected} value={total_contact_zalo} title="Tổng danh bạ từ Zalo" />
          </Paper>

        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper onClick={() => onChangeChannel({ channel: "system" })} sx={{ cursor: 'pointer' }}>
            <AnalytysStatisticalContactSystem channelSelected={channelSelected} value={total_contact_system} title="Tổng danh bạ từ hệ thống" />
          </Paper>
        </Grid>
      </Grid>
      {/* <Search handleParamSearch={handleParamSearch} /> */}
    </>
  );
}
